import { react, useEffect } from 'react';
import HeaderSlogan from './HeaderSlogan';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import HomeIcon from '@mui/icons-material/Home';

import ReactGA from 'react-ga4';
ReactGA.initialize([{trackingId: process.env.REACT_APP_GOOGLE_TAG}]);

const About = () => {

    useEffect(() => {
        if (window.location.href.indexOf('localhost') == -1 && window.location.href.toLowerCase().indexOf('test.sipzee.com') == -1) {
            ReactGA.send({ hitType: "pageview", page: '/About' });
        }
    }, []);

    return (
        <div style={{display:'flex', justifyContent:'center', flexDirection:'column',padding:'10px' } }>
            <HeaderSlogan />

 

            <div style={{ marginTop: '15px', alignSelf: 'center', maxWidth: '600px' }}>
                <div style={{ color: 'var(--sipzee-yellow)', fontSize: '12pt', fontWeight:'bold', textAlign:'left' } }>
                    About Sipzee
                </div>
                <div style={{ color: 'var(--sipzee-grey)', fontSize: '18pt', fontWeight:'bold', textAlign:'left' } }>
                    Simplify Recycling. Create Jobs. Support Communities.
                </div>
                <div style={{ textAlign: 'left', fontWeight:'600', lineHeight:'1.7rem', fontSize:'1rem',marginTop:'15px' }}>
                    Sipzee is based out of Grand Rapids, Michigan and launched in 2020.
                    Our company was founded on the idea of simplifying recycling, creating jobs,
                    supporting local charities & fundraisers,
                    and keeping Michigan communities safer amid the COVID-19 pandemic.
                </div>
            </div>

            <div style={{
                marginTop: '15px', fontSize: '14pt', alignSelf: 'center', maxWidth: '600px',
                display: 'flex', flexDirection: 'column'
            }}>
                Have a question about how Sipzee works? Please see our
                <Button
                    component={Link}
                    to='/FAQ'
                    style={{ alignSelf: 'center', maxWidth: '225px' }}
                    sx={{ my: 2, display: 'flex', background: 'var(--sipzee-yellow)' }}
                ><HelpOutlineIcon style={{ alignSelf: 'center' }} /> Frequently Asked Questions
                </Button>
            </div>

            <div style={{ marginTop: '15px', alignSelf: 'center', maxWidth: '600px', textAlign:'left' }}>
                <div style={{ fontWeight: 'bold', fontSize: '14pt', display:'flex' }}>
                    <HomeIcon sx={{ color: 'var(--sipzee-green)', fontSize: 50, alignSelf:'center', marginRight:'5px' }} />
                    <div style={{ alignSelf: 'center' }}>For Households and Businesses</div>
                </div>
                <img style={{ width: '215px', float: 'left', paddingRight: '5px' }} src='/images/Customer_Marketing.png' />
                Through our free user-friendly web app and network of local returners,
                Sipzee offers Michigan households a quick and hassle-free method for
                recycling bottles and cans without leaving the comfort of their home.
                Sipzee PAYS YOU electronically for cans & bottles after your contactless pick
                up is complete. The app includes a built-in quantity estimator tool so there
                is no need to get your hands dirty counting cans & bottles while using Sipzee.
                In addition, you have the option to donate the money from your cans & bottles
                to local non-profits and fundraisers that have signed up in your area.
                Using the Sipzee app helps reduces potential exposure to the COVID-19 virus
                and decreases congestion in stores where the virus is more likely to spread.
                Go to www.sipzee.com to get started - no need to sign up or download anything.
            </div>

            <div style={{ marginTop: '15px', alignSelf: 'center', maxWidth: '600px', textAlign:'left' }}>
                <div style={{ fontWeight: 'bold', fontSize: '14pt', display:'flex' }}>
                    <DirectionsCarIcon sx={{ color: 'var(--sipzee-green)', fontSize: 50, alignSelf: 'center', marginRight: '5px' }} />
                    <div style={{ alignSelf: 'center'}}>For Drivers/Bottle Recyclers</div>
                </div>
                <img style={{ width: '215px', float: 'left' ,paddingRight:'5px' }} src='/images/Returner_Marketing.png' />
                Sipzee helps create local jobs through our Sipzee returner program.
                Anyone ages 16 or older, can Sign Up to become a Sipzee returner for free.
                Once you complete the account setup and training program, you will be given
                access to our full market of available pickup requests in your area so you can
                start working and getting paid while providing recycling services.
            </div>

            <div style={{ marginTop: '15px', alignSelf: 'center', maxWidth: '600px' }}>
                <Button
                    component={Link}
                    to='/Pickup'
                    sx={{ my: 2, display: 'block', background:'var(--sipzee-green)' }}
                >Ready to Try Sipzee?
                </Button>
            </div>

            <div style={{ marginTop: '15px', alignSelf: 'center', maxWidth: '600px' }}>
                <div>Still have questions?</div>
                <Button
                    component={Link}
                    to='/ContactUs'
                    sx={{ my: 2, display: 'block', background: 'var(--sipzee-yellow)' }}
                >Contact Us
                </Button>
            </div>
        </div>    
    )
}

export default About;